import styled from 'styled-components/native'

export const RemoveActivityContainer = styled.Text<{
    highlightcolor: string
}>`
    margin-left: 10px;
    color: ${({ highlightcolor }) =>
    highlightcolor ? highlightcolor + 15 : '#fff'};
`
